"use client";

import type { FC } from "react";
import { Suspense } from "react";

import { isPreviewing } from "@builder.io/sdk-react";

import { StoreDetails as UIStoreDetails } from "@des/locators/components/StoreDetails";

import type { storeDetailsInputs } from "@/components/StoreDetails/StoreDetails.builder";

import { Placeholder } from "../Placeholder/Placeholder";

type StoreDetailsBuilderProps = BuilderComponentProps<typeof storeDetailsInputs>;

export const StoreDetails: FC<StoreDetailsBuilderProps> = ({ storeLocatorUrl, componentLevelLanguage }) => {
  return (
    <Suspense>
      <StoreDetailsContent storeLocatorUrl={storeLocatorUrl} componentLevelLanguage={componentLevelLanguage} />
    </Suspense>
  );
};

export function StoreDetailsContent({ storeLocatorUrl, componentLevelLanguage }: StoreDetailsBuilderProps) {
  if (isPreviewing()) {
    return <Placeholder>Store Details.</Placeholder>;
  }

  return <UIStoreDetails storeLocatorUrl={storeLocatorUrl} componentLevelLanguage={componentLevelLanguage} />;
}
